import { SignInWatcher, SignOutWatcher } from "./user";
import {
  GetCarouselDataWatcher,
  AddCarouselDataWatcher,
  RemoveCarouselDataWatcher,
  UpdateCarouselDataWatcher
} from "./carousel";
import {
  GetFamilyDataWatcher,
  AddFamilyDataWatcher,
  RemoveFamilyDataWatcher,
  UpdateFamilyDataWatcher
} from "./family";
import { GetAboutDataWatcher, RemoveAboutDataWatcher, AddAboutDataWatcher, UpdateAboutDataWatcher } from "./about";
import { GetContactDataWatcher, SetContactDataWatcher } from "./contact";
import { GetMenuDataWatcher, SetMenuDataWatcher } from "./menu";
import {
  CreateCategoryWatcher,
  GetCategoriesWatcher,
  UpdateCategoryWatcher,
  RemoveCategoryWatcher
} from "./categories";
import { GetProductsWatcher, CreateProductWatcher, RemoveProductWatcher, UpdateProductWatcher } from "./products";
import { GetFooterDataWatcher, SetFooterDataWatcher } from "./footer";
import { GetHomepageDataWatcher } from "./homepage";
import { GetSectionsWatcher } from "./sections";
import { GetCertificatesWatcher } from "./certificates";
import { GetProductionDataWatcher, SetProductionDataWatcher } from "./production";
import { all } from "redux-saga/effects";

export default function* rootSaga() {
  yield all([
    // auth sagas
    SignInWatcher(),
    SignOutWatcher(),
    // sections
    GetSectionsWatcher(),
    // homepage
    GetHomepageDataWatcher(),
    // landing menu section sagas
    GetMenuDataWatcher(),
    SetMenuDataWatcher(),
    // about section sagas
    GetAboutDataWatcher(),
    AddAboutDataWatcher(),
    RemoveAboutDataWatcher(),
    UpdateAboutDataWatcher(),
    // carousel section sagas
    GetCarouselDataWatcher(),
    AddCarouselDataWatcher(),
    RemoveCarouselDataWatcher(),
    UpdateCarouselDataWatcher(),
    // UploadCarouselDataWatcher(),
    // RemoveCarouselDataWatcher(),
    // family section sagas
    GetFamilyDataWatcher(),
    AddFamilyDataWatcher(),
    RemoveFamilyDataWatcher(),
    UpdateFamilyDataWatcher(),
    // category section sagas
    CreateCategoryWatcher(),
    RemoveCategoryWatcher(),
    GetCategoriesWatcher(),
    UpdateCategoryWatcher(),
    // products section sagas
    GetProductsWatcher(),
    CreateProductWatcher(),
    RemoveProductWatcher(),
    UpdateProductWatcher(),
    // contact section sagas
    GetContactDataWatcher(),
    SetContactDataWatcher(),
    // footer section sagas
    GetFooterDataWatcher(),
    SetFooterDataWatcher(),
    GetCertificatesWatcher(),
    GetProductionDataWatcher(),
    SetProductionDataWatcher()
  ]);
}
